module.exports = __webpack_public_path__ + "img/camara.1eec122a.svg";